// @mui material components
import Container from "@mui/material/Container";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import propertyData from "pages/Home/sections/data/propertyData";

function AboutProperty() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <MKTypography variant="h3" mb={2}>
          About The Property
        </MKTypography>
        {propertyData.description.split("\n\n").map((paragraph, i) => (
          <MKTypography key={i} variant="body1" color="text" mb={2}>
            {paragraph.trim()}
          </MKTypography>
        ))}
      </Container>
    </MKBox>
  );
}

export default AboutProperty;
